import React from "react";
import { ValueTableRuleBuilder } from "../ValueTableRuleBuilder";
import { getValueTableString, getValueTableStringList } from "../Testing/TestDataSetup";
import { StoryNode } from "../../../../CommonUI/StoryBook/StoryData";

export const ValueTableStringStories = [
    new StoryNode(
        () => {
            let ruleDefinition = getValueTableString();

            return <ValueTableRuleBuilder ruleDefinition={ruleDefinition} />;
        },
        "Rule Builder",
        "Value Table",
        "String",
        "Value"
    ),

    new StoryNode(
        () => {
            let ruleDefinition = getValueTableStringList();

            return <ValueTableRuleBuilder ruleDefinition={ruleDefinition} />;
        },
        "Rule Builder",
        "Value Table",
        "String",
        "List"
    ),
];
